// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Agency360 / ViiB portal design system */

body {
  font-family: var(--font);
  background: var(--bg);
  color: var(--text);
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4 {
  color: var(--text);
  letter-spacing: -0.02em;
}

a {
  color: var(--primary);
}

a:hover {
  color: var(--primary-hover);
  text-decoration: none;
}

.muted {
  color: var(--text-muted);
}

.eyebrow {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 0.2rem;
}

.btn-primary,
.btn-secondary,
.btn-danger,
.btn-link {
  font-family: inherit;
  font-weight: 600;
  border-radius: 10px;
  padding: 0.55rem 1.05rem;
  font-size: 0.9rem;
  line-height: 1.25;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
}

.btn-primary {
  background: var(--primary);
  color: #fff;
  border: 1px solid var(--primary);
  box-shadow: 0 1px 2px rgb(79 70 229 / 25%);
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  color: #fff;
}

.btn-secondary {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--primary-soft);
  border-color: #c7d2fe;
  color: var(--primary);
}

.btn-danger {
  background: var(--danger);
  color: #fff;
  border: 1px solid var(--danger);
}

.btn-link {
  background: #fff;
  color: var(--primary);
  border: 1px solid var(--border);
}

.btn-link:hover {
  background: var(--primary-soft);
  border-color: #c7d2fe;
}

.auth-shell {
  background:
    radial-gradient(circle at top left, rgb(79 70 229 / 10%), transparent 34%),
    radial-gradient(circle at bottom right, rgb(59 130 246 / 10%), transparent 32%),
    var(--bg);
}

.auth-card,
.auth-card.flat,
.card-panel,
.table-wrap {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.auth-card {
  padding: 2rem 1.75rem;
}

.auth-card.flat {
  padding: 1.15rem 1.2rem;
  box-shadow: var(--shadow);
}

.auth-card h1 {
  font-size: 1.5rem;
  font-weight: 800;
}

.field span {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']),
  .field > textarea,
  .field > select,
  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),
  .stack > textarea,
  .stack > select,
  .inline-two input:not([type='checkbox']):not([type='radio']),
  .inline-two select,
  .row-actions > select,
  .form-control,
  .form-select,
  .searchable-select-trigger
) {
  border-radius: 10px;
  border-color: #dbe3ee;
  box-shadow: none;
}

:is(
  .field > input:not([type='checkbox']):not([type='radio']):focus,
  .field > textarea:focus,
  .field > select:focus,
  .form-control:focus,
  .form-select:focus,
  .searchable-select-trigger:focus
) {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgb(79 70 229 / 15%);
  outline: none;
}

.dashboard {
  background: var(--portal-content-bg, var(--bg));
}

.app-shell.dashboard {
  display: grid;
  grid-template-columns: 16.75rem minmax(0, 1fr);
  min-height: 100vh;
  transition: grid-template-columns 0.2s ease;
}

.app-shell.dashboard.is-sidebar-collapsed {
  grid-template-columns: 0 minmax(0, 1fr);
}

.sidebar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 0;
  padding: 1.15rem 0.9rem 0.9rem;
  background: #f1f3f9;
  border-right: 1px solid #e6eaf2;
  overflow: hidden;
}

.app-shell.is-sidebar-collapsed .sidebar {
  padding: 0;
  border-right: 0;
  visibility: hidden;
}

.sidebar .portal-brand-header {
  padding: 0 0.45rem 1rem;
}

.sidebar .portal-brand-header h1 {
  font-size: 1.02rem;
  line-height: 1.2;
  color: #3f51b5;
}

.portal-brand-header--wordmark {
  flex-direction: column;
  align-items: flex-start;
  gap: 0.2rem;
}

.agency-wordmark {
  display: block;
  height: 1.35rem;
  width: auto;
  max-width: 11.5rem;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 0.15rem;
}

.sidebar-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  flex-shrink: 0;
}

.sidebar-link,
.sidebar-group-trigger {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  padding: 0.58rem 0.7rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #475569;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.sidebar-link:hover,
.sidebar-group-trigger:hover {
  background: #e8eefc;
  color: #3f51b5;
  text-decoration: none;
}

.sidebar-link.is-active,
.sidebar-group.is-active > .sidebar-group-trigger {
  background: #e3eafc;
  color: #3f51b5;
  font-weight: 700;
}

.sidebar-group-label {
  flex: 1;
}

.sidebar-group-chevron {
  font-size: 0.65rem;
  opacity: 0.7;
  transition: transform 0.15s ease;
}

.sidebar-group.is-open .sidebar-group-chevron {
  transform: rotate(180deg);
}

.sidebar-group-panel {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.15rem 0 0.35rem 1.85rem;
}

.sidebar-group-panel[hidden] {
  display: none;
}

.sidebar-more-panel {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.1rem 0 0.15rem 0.45rem;
}

.sidebar-more-panel[hidden] {
  display: none;
}

.sidebar-sublink {
  padding: 0.42rem 0.65rem;
  border-radius: 8px;
  color: #64748b;
  font-size: 0.84rem;
  text-decoration: none;
}

.sidebar-sublink:hover {
  background: #f8fafc;
  color: var(--text);
  text-decoration: none;
}

.sidebar-sublink.is-active {
  background: var(--primary-soft);
  color: var(--primary);
  font-weight: 600;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 0.75rem;
}

.sidebar-help {
  padding: 0.9rem 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.sidebar-help strong {
  display: block;
  font-size: 0.88rem;
}

.sidebar-help p {
  margin: 0.3rem 0 0.7rem;
  font-size: 0.78rem;
  color: var(--text-muted);
}

.sidebar-help-btn {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.7rem;
  border-radius: 8px;
  background: #eef2ff;
  color: #3f51b5;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
}

.sidebar-help-btn:hover {
  background: #e0e7ff;
  color: #3f51b5;
  text-decoration: none;
}

.app-shell-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 4rem;
  padding: 0.7rem 1.5rem;
  background: var(--portal-header-bg, var(--surface));
  border-bottom: 1px solid var(--border);
}

.topbar-spacer {
  flex: 1;
}

.topbar-search {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex: 1;
  max-width: 36rem;
  min-width: 0;
  margin: 0;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: #f1f5f9;
  color: #94a3b8;
}

.topbar-search input {
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 0.9rem;
  outline: none;
}

.topbar-utilities {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-left: auto;
  flex-shrink: 0;
}

.icon-btn.topbar-menu-btn {
  display: inline-flex;
  flex-shrink: 0;
}

.sidebar-backdrop {
  display: none;
}

.dashboard-header {
  display: none;
}

.dashboard-header h1 {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.portal-brand-logo {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 10px;
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 10px;
  background: var(--primary);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 800;
  flex-shrink: 0;
}

.header-nav {
  flex: 1;
  justify-content: flex-end;
  gap: 0.15rem;
}

.header-nav-link,
.nav-dropdown-trigger {
  padding: 0.5rem 0.7rem;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--text-muted);
  font-weight: 500;
  box-shadow: none;
}

.header-nav-link:hover,
.nav-dropdown-trigger:hover,
.nav-dropdown.is-open .nav-dropdown-trigger {
  background: transparent;
  color: var(--text);
  border-color: transparent;
}

.header-nav-link.is-active,
.nav-dropdown.is-active .nav-dropdown-trigger {
  background: transparent;
  border: none;
  color: var(--primary);
  font-weight: 600;
  box-shadow: inset 0 -2px 0 var(--primary);
}

.nav-dropdown-panel {
  border-radius: 12px;
  border-color: var(--border);
  box-shadow: var(--shadow-md);
  padding: 0.4rem;
}

.nav-dropdown-item {
  border-radius: 8px;
}

.nav-dropdown-item.is-active {
  background: var(--primary-soft);
  color: var(--primary);
}

.header-nav-utilities {
  gap: 0.45rem;
  padding-left: 0.9rem;
  margin-left: 0.5rem;
}

.dashboard-main {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 1.5rem 1.5rem 3rem;
}

.icon-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  border: 1px solid var(--border);
  border-radius: 999px;
  background: #fff;
  color: var(--text);
  cursor: pointer;
}

.icon-btn:hover {
  background: var(--primary-soft);
  border-color: #c7d2fe;
  color: var(--primary);
}

.icon-btn-badge {
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  min-width: 1.05rem;
  height: 1.05rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: var(--danger);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.05rem;
  text-align: center;
}

.priority-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: var(--primary-soft);
  color: var(--primary);
  font-size: 0.72rem;
  font-weight: 700;
}

.user-menu {
  position: relative;
}

.user-menu-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.15rem 0.4rem 0.15rem 0.15rem;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  color: inherit;
}

.user-menu-trigger:hover,
.user-menu.is-open .user-menu-trigger {
  background: #f8fafc;
  border-color: var(--border);
}

.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 999px;
  background: var(--primary);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
}

.user-menu-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
  text-align: left;
}

.user-menu-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text);
}

.user-menu-role {
  font-size: 0.7rem;
  color: var(--text-muted);
}

.user-menu-panel {
  display: none;
  position: absolute;
  right: 0;
  top: calc(100% + 0.4rem);
  min-width: 12rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  z-index: 220;
}

.user-menu.is-open .user-menu-panel {
  display: block;
}

.user-menu-item {
  display: block;
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text);
  font-size: 0.9rem;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.user-menu-item:hover {
  background: #f8fafc;
  color: var(--text);
}

.notif-bell {
  position: relative;
}

.notif-bell-panel {
  position: absolute;
  right: 0;
  top: calc(100% + 0.45rem);
  z-index: 230;
  width: min(22rem, 80vw);
  padding: 0.9rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
}

.notif-bell-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.65rem;
}

.page-welcome {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.35rem;
}

.page-welcome-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.page-welcome-sub {
  margin: 0.3rem 0 0;
  color: var(--text-muted);
}

.page-welcome-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.stat-grid,
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.9rem;
}

.kpi-card {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 1rem 1.05rem 0.9rem;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  text-decoration: none;
  color: inherit;
}

.kpi-card--link:hover {
  border-color: #c7d2fe;
  box-shadow: var(--shadow-md);
  text-decoration: none;
  color: inherit;
}

.kpi-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.kpi-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  height: 2.15rem;
  border-radius: 10px;
}

.kpi-card--purple .kpi-card-icon { background: var(--primary-soft); color: var(--primary); }
.kpi-card--danger .kpi-card-icon { background: var(--danger-soft); color: var(--danger); }
.kpi-card--warning .kpi-card-icon { background: var(--warning-soft); color: #d97706; }
.kpi-card--info .kpi-card-icon { background: var(--info-soft); color: var(--info); }
.kpi-card--success .kpi-card-icon { background: var(--success-soft); color: var(--success); }
.kpi-card--default .kpi-card-icon { background: #f1f5f9; color: #475569; }

.kpi-card-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.kpi-card-value {
  font-size: 1.65rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1;
}

.kpi-card-hint,
.kpi-card-link {
  font-size: 0.8rem;
  color: var(--primary);
}

.kpi-card-hint {
  color: var(--text-muted);
}

.dash-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(18rem, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

.dash-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1.1rem 1.15rem;
}

.panel > * {
  min-width: 0;
}

.panel h3,
.panel-title {
  margin: 0 0 0.85rem;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #334155;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  flex: none;
}

.panel-head h3,
.panel-head .panel-title {
  margin: 0;
}

.panel-link {
  display: inline-flex;
  align-items: center;
  flex: none;
  margin: 0;
  padding: 0.28rem 0.7rem;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  background: #fff;
  color: var(--primary);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.01em;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.panel-link:hover {
  background: var(--primary-soft);
  border-color: #a5b4fc;
  color: var(--primary-hover);
  text-decoration: none;
}

.panel-link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgb(79 70 229 / 18%);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.status-badge-dot {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 999px;
  background: currentColor;
}

.status-badge--success { background: var(--success-soft); color: #047857; }
.status-badge--warning { background: var(--warning-soft); color: #b45309; }
.status-badge--danger { background: var(--danger-soft); color: #b91c1c; }
.status-badge--info { background: var(--info-soft); color: #1d4ed8; }
.status-badge--purple { background: var(--primary-soft); color: var(--primary); }
.status-badge--rose { background: #fdf4ff; color: #a21caf; }
.status-badge--neutral { background: #f1f5f9; color: #475569; }

.progress-block {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.progress-block-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text);
}

.progress-track {
  height: 8px;
  border-radius: 999px;
  background: #eef2f7;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
}

.progress-fill--info { background: var(--info); }
.progress-fill--success { background: var(--success); }
.progress-fill--warning { background: var(--warning); }
.progress-fill--danger { background: var(--danger); }
.progress-fill--purple { background: var(--primary); }

.attention-list {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.attention-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.8rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
  text-decoration: none;
  color: inherit;
}

.attention-item:hover {
  border-color: #c7d2fe;
  text-decoration: none;
  color: inherit;
}

.attention-item--button {
  width: 100%;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.attention-copy {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  flex: 1;
}

.attention-action {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--primary);
  white-space: nowrap;
}

.attention-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  flex-shrink: 0;
}

.attention-icon--danger { background: var(--danger-soft); color: var(--danger); }
.attention-icon--warning { background: var(--warning-soft); color: #d97706; }
.attention-icon--info { background: var(--info-soft); color: var(--info); }
.attention-icon--success { background: var(--success-soft); color: var(--success); }

.action-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.action-cta--danger { color: var(--danger); border: 1px solid #fecaca; background: #fff; }
.action-cta--warning { color: #b45309; border: 1px solid #fde68a; background: #fff; }
.action-cta--info { color: var(--info); border: 1px solid #bfdbfe; background: #fff; }
.action-cta--purple { color: #fff; border: 1px solid var(--primary); background: var(--primary); }

.timeline-stages {
  list-style: none;
  margin: 0;
  padding: 0;
}

.timeline-stages li {
  position: relative;
  padding: 0 0 1rem 1.6rem;
  border-bottom: none;
}

.timeline-stages li:last-child {
  padding-bottom: 0;
}

.timeline-stages li::before {
  content: '';
  position: absolute;
  left: 0.42rem;
  top: 1.15rem;
  bottom: 0;
  width: 2px;
  background: #e2e8f0;
}

.timeline-stages li:last-child::before {
  display: none;
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 0.15rem;
  width: 0.95rem;
  height: 0.95rem;
  border-radius: 999px;
  border: 2px solid #cbd5e1;
  background: #fff;
}

.timeline-dot--done {
  background: var(--success);
  border-color: var(--success);
}

.timeline-dot--current {
  background: var(--info);
  border-color: var(--info);
  box-shadow: 0 0 0 4px rgb(59 130 246 / 18%);
}

.help-card {
  background: linear-gradient(180deg, #eef2ff 0%, #fff 48%);
  border-color: #e0e7ff;
}

.help-card .help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 12px;
  background: var(--primary);
  color: #fff;
  margin-bottom: 0.7rem;
}

.track-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding: 0.95rem 1.15rem;
  border-radius: var(--radius);
  background: #eff6ff;
  border: 1px solid #dbeafe;
  color: #1e40af;
  font-weight: 600;
}

.project-hero {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1.2rem 1.25rem;
  margin-bottom: 1rem;
}

.project-hero-crumb {
  margin-bottom: 0.75rem;
  font-size: 0.85rem;
}

.project-hero-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.project-hero-identity {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  min-width: 0;
}

.project-hero-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 14px;
  background: var(--primary-soft);
  color: var(--primary);
  font-weight: 800;
  font-size: 1.2rem;
}

.project-hero-title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.project-hero-title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 800;
}

.project-hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.project-hero-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  gap: 0.85rem;
  margin-top: 1rem;
}

.workspace-tabs {
  gap: 0.15rem;
  border-bottom: 1px solid var(--border);
  margin-top: 0.25rem;
}

.workspace-tab {
  border: none;
  background: transparent;
  color: var(--text-muted);
  border-radius: 0;
  padding: 0.7rem 0.85rem;
  font-weight: 600;
}

.workspace-tab.active {
  background: transparent;
  color: var(--primary);
  box-shadow: inset 0 -2px 0 var(--primary);
}

.data-table th {
  background: #f8fafc;
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.data-table td {
  padding: 0.8rem 0.9rem;
  vertical-align: middle;
}

/* Keep action cells in the table grid. display:flex on a td drops it out of
   the row, so borders and buttons shift on taller rows. */
table :is(td, th).row-actions {
  display: table-cell;
  width: 1%;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

table :is(td, th).row-actions > * {
  vertical-align: middle;
}

table :is(td, th).row-actions > * + * {
  margin-left: 0.5rem;
}

.data-table tbody tr:hover td {
  background: #f8fafc;
}

.quick-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem 0.85rem;
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.quick-nav a {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-muted);
}

.quick-nav a:hover {
  color: var(--primary);
}

.empty-state {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.feed-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.feed-list li {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.7rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.feed-list li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 8.5rem;
  padding: 1.25rem;
  border: 1.5px dashed #c7d2fe;
  border-radius: 14px;
  background: #f8faff;
  text-align: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.dropzone:hover,
.dropzone.is-active {
  border-color: var(--primary);
  background: #eef2ff;
  text-decoration: none;
  color: inherit;
}

.dropzone.is-busy {
  cursor: progress;
}

.dropzone input[type='file'] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.asset-drop-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgb(238 242 255 / 88%);
  pointer-events: none;
}

.asset-drop-overlay-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  min-width: min(28rem, 100%);
  padding: 2rem 1.5rem;
  border: 2px dashed var(--primary);
  border-radius: 16px;
  background: #fff;
  text-align: center;
}

.chat-widget-fab {
  background: var(--primary);
  box-shadow: 0 8px 24px rgb(79 70 229 / 28%);
}

.modal-panel {
  border-radius: 16px;
}

.dashboard-main h2[data-tour="page-title"] {
  font-size: 1.55rem;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.dashboard-integrations-card h3 {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.kpi-mini-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.kpi-mini {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.7rem 0.9rem;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
}

.kpi-mini:hover {
  border-color: #c7d2fe;
  text-decoration: none;
  color: inherit;
}

.kpi-mini strong {
  font-size: 1.15rem;
  letter-spacing: -0.03em;
}

.my-work {
  margin-bottom: 1.35rem;
}

.my-work-counts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(7.5rem, 1fr));
  gap: 0.65rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.my-work-count {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #f8fafc;
}

.my-work-count strong {
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1;
}

.my-work-count span {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.my-work-count.is-zero strong {
  color: #94a3b8;
}

.my-work-count--danger:not(.is-zero) {
  background: var(--danger-soft);
  border-color: transparent;
}

.my-work-count--danger:not(.is-zero) strong {
  color: #b91c1c;
}

.my-work-count--warning:not(.is-zero) {
  background: var(--warning-soft);
  border-color: transparent;
}

.my-work-count--warning:not(.is-zero) strong {
  color: #b45309;
}

.my-work-count--info:not(.is-zero) {
  background: var(--info-soft);
  border-color: transparent;
}

.my-work-count--info:not(.is-zero) strong {
  color: #1d4ed8;
}

.my-work-count--neutral:not(.is-zero) {
  background: #f1f5f9;
  border-color: transparent;
}

.my-work-empty {
  margin: 0.85rem 0 0;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.my-work-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin: 0.9rem 0 0;
  padding: 0;
  list-style: none;
}

.my-work .my-work-task {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
  color: var(--text);
  text-decoration: none;
}

.my-work .my-work-task:hover {
  border-color: #c7d2fe;
  color: var(--text);
  text-decoration: none;
}

.my-work .my-work-task .muted {
  color: var(--text-muted);
}

.my-work-list,
.my-work-list > li {
  min-width: 0;
  max-width: 100%;
}

.my-work-task-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.12rem;
  min-width: 0;
  max-width: 100%;
}

.my-work-task-copy strong {
  display: block;
  overflow: hidden;
  font-size: 0.92rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chip-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.85rem;
}

.chip-tab {
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-muted);
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}

.chip-tab.is-active {
  background: var(--primary-soft);
  border-color: #c7d2fe;
  color: var(--primary);
}

.scope-toggle {
  display: inline-flex;
  padding: 0.2rem;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #e0e7ff;
}

.scope-toggle button {
  border: 0;
  background: transparent;
  color: var(--text-muted);
  border-radius: 999px;
  padding: 0.4rem 0.85rem;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
}

.scope-toggle button.is-active {
  background: var(--primary);
  color: #fff;
}

.lead-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.82rem;
  font-weight: 600;
}

.lead-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 999px;
  background: var(--primary-soft);
  color: var(--primary);
  font-size: 0.65rem;
  font-weight: 800;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.file-row:last-child {
  border-bottom: 0;
}

.file-glyph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 8px;
  background: var(--success-soft);
  color: var(--success);
  font-size: 0.65rem;
  font-weight: 800;
}

.connected-apps {
  display: grid;
  gap: 0.55rem;
}

.connected-app {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid var(--border);
  border-radius: 10px;
}

.donut-wrap {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.donut {
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 999px;
  flex-shrink: 0;
}

.workspace-tabs-more {
  position: relative;
}

.workspace-more-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 0.35rem);
  z-index: 8;
  min-width: 12rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
}

.workspace-more-menu button {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 0.5rem 0.7rem;
  border-radius: 8px;
  font: inherit;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
}

.workspace-more-menu button:hover,
.workspace-more-menu button.is-active {
  background: var(--primary-soft);
  color: var(--primary);
}

.hero-more {
  position: relative;
}

.hero-more-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 0.35rem);
  z-index: 8;
  min-width: 13rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
}

.hero-more-menu button,
.hero-more-menu a {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 0.5rem 0.7rem;
  border-radius: 8px;
  font: inherit;
  font-weight: 600;
  color: var(--text);
  cursor: pointer;
  text-decoration: none;
}

.hero-more-menu button:hover,
.hero-more-menu a:hover {
  background: #f8fafc;
  text-decoration: none;
}

.hero-more-menu .is-danger {
  color: var(--danger);
}

.usage-stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.usage-stat:last-child {
  border-bottom: 0;
}

.panel-search {
  min-width: 12rem;
  flex: 1;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1024px) {
  .dash-grid,
  .dash-grid-3,
  .kpi-mini-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .my-work-counts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .my-work .my-work-task {
    align-items: stretch;
    flex-direction: column;
  }

  .my-work-task-copy {
    flex: none;
    width: 100%;
  }

  .my-work .my-work-task .status-badge {
    align-self: flex-start;
  }
}

@media (max-width: 960px) {
  .app-shell,
  .app-shell.dashboard,
  .app-shell.dashboard.is-sidebar-collapsed {
    grid-template-columns: 1fr;
  }

  .icon-btn.topbar-menu-btn {
    display: inline-flex;
  }

  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: min(18rem, 86vw);
    transform: translateX(-110%);
    transition: transform 0.2s ease, visibility 0.2s ease;
    box-shadow: var(--shadow-md);
    visibility: hidden;
    padding: 1.15rem 0.9rem 0.9rem;
    border-right: 1px solid #e6eaf2;
  }

  .app-shell.is-sidebar-open .sidebar {
    transform: none;
    visibility: visible;
  }

  .sidebar-backdrop {
    display: none;
    position: fixed;
    inset: 0;
    z-index: 25;
    border: 0;
    background: rgb(15 23 42 / 45%);
  }

  .app-shell.is-sidebar-open .sidebar-backdrop {
    display: block;
  }
}

@media (max-width: 900px) {
  .topbar .user-menu-meta {
    display: none;
  }

  .page-welcome-title {
    font-size: 1.4rem;
  }

  .action-cta {
    width: 100%;
  }
}

.form-choice-list {
  display: grid;
  gap: 0.35rem;
}

.form-choice {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-weight: 600;
}

.form-rating {
  display: flex;
  gap: 0.35rem;
}

.form-rating-btn {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  font-weight: 700;
}

.form-rating-btn.is-on {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.media-library-page,
.media-library {
  width: 100%;
}

.media-library-page > .auth-card:first-child {
  position: relative;
  z-index: 2;
}

.media-library-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 0.75rem;
}

.media-library-head .panel-title {
  margin-bottom: 0.2rem;
}

.media-upload-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.dropzone--compact {
  min-height: 4.25rem;
  padding: 0.75rem 1rem;
}

.media-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: center;
  margin: 0.25rem 0 0.9rem;
}

.media-toolbar input[type='search'] {
  flex: 1 1 12rem;
  min-width: 10rem;
}

.media-filters,
.media-view-toggle {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.media-filters button,
.media-view-toggle button,
.media-menu-panel button {
  border: 1px solid var(--border);
  background: #fff;
  border-radius: 999px;
  padding: 0.28rem 0.7rem;
  font-size: 0.8rem;
  cursor: pointer;
}

.media-filters button.is-active,
.media-view-toggle button.is-active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.media-sort {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.media-sort select {
  min-width: 8rem;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.85rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.media-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
  min-width: 0;
}

.media-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 4 / 3;
  padding: 0;
  border: 0;
  border-bottom: 1px solid var(--border);
  border-radius: 11px 11px 0 0;
  background: #f1f5f9;
  cursor: pointer;
  overflow: hidden;
}

.media-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-preview--missing {
  color: #b91c1c;
  font-size: 0.85rem;
  font-weight: 600;
}

.media-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3.4rem;
  height: 2.2rem;
  padding: 0 0.45rem;
  border-radius: 8px;
  background: #e2e8f0;
  color: #1e293b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.media-type-icon--document {
  background: #fee2e2;
  color: #991b1b;
}

.media-type-icon--video {
  background: #dbeafe;
  color: #1d4ed8;
}

.media-type-icon--image {
  background: #dcfce7;
  color: #166534;
}

.media-card-body {
  padding: 0.65rem 0.7rem 0.75rem;
}

.media-card-title {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
}

.media-card-title strong {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
}

.media-card-meta {
  margin-top: 0.2rem;
}

.media-menu {
  position: relative;
  flex-shrink: 0;
}

.media-menu-button {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-weight: 800;
  letter-spacing: 0.08em;
  line-height: 1;
  padding: 0.15rem 0.25rem;
}

.media-menu-panel {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 30;
  display: grid;
  min-width: 11rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow);
}

.media-menu-panel button {
  border-radius: 8px;
  text-align: left;
  background: transparent;
}

.media-menu-panel button.is-danger {
  color: #b91c1c;
}

.media-table button.linkish {
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--primary);
  cursor: pointer;
  font-weight: 600;
  text-align: left;
}

.media-pending {
  margin-bottom: 0.9rem;
  padding: 0.75rem 0.85rem;
  border: 1px solid #fde68a;
  border-radius: 10px;
  background: #fffbeb;
}

.media-pending h4 {
  margin: 0 0 0.4rem;
  font-size: 0.9rem;
}

.media-pending ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.media-pending li {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.25rem 0;
}

.media-lightbox {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: rgb(15 23 42 / 88%);
  color: #fff;
}

.media-lightbox-bar {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  padding: 0.85rem 1rem;
}

.media-lightbox-bar strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-lightbox-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.media-lightbox-stage {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem 1.5rem;
}

.media-lightbox-stage img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
}

.media-lightbox-note,
.media-lightbox-file {
  max-width: 28rem;
  text-align: center;
  color: #e2e8f0;
}

.media-lightbox-file {
  display: grid;
  justify-items: center;
  gap: 0.45rem;
}

@media (max-width: 720px) {
  .media-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }

  .media-lightbox-bar {
    align-items: flex-start;
    flex-direction: column;
  }
}

.access-layout {
  display: grid;
  grid-template-columns: minmax(14rem, 18rem) minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
}

.access-roles,
.access-editor,
.access-member,
.access-group {
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  background: #fff;
  padding: 1rem;
}

.access-role-list {
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  display: grid;
  gap: 0.4rem;
}

.access-role {
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  background: #f8fafc;
  border-radius: 8px;
  padding: 0.55rem 0.7rem;
  display: grid;
  gap: 0.15rem;
}

.access-role.active {
  border-color: var(--primary, #2563eb);
  background: #eff6ff;
}

.access-group-head {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: flex-start;
}

.access-group h4,
.access-roles h3,
.access-editor h3,
.access-member h3 {
  margin: 0 0 0.35rem;
}

.access-permissions,
.access-overrides {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: grid;
  gap: 0.55rem;
}

.access-permissions label {
  display: flex;
  gap: 0.65rem;
  align-items: flex-start;
}

.access-permissions label span {
  display: grid;
  gap: 0.1rem;
}

.access-overrides li {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12rem;
  gap: 0.75rem;
  align-items: center;
}

.access-editor,
.access-member {
  display: grid;
  gap: 0.85rem;
}

@media (max-width: 900px) {
  .access-layout {
    grid-template-columns: 1fr;
  }

  .access-overrides li {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/ui.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;;;EAIE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;;;EAIE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,mGAAmG;AACrG;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE;;;aAGW;AACb;;AAEA;;;;EAIE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;EAcE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,mCAAmC,+BAA+B,EAAE,qBAAqB,EAAE;AAC3F,mCAAmC,8BAA8B,EAAE,oBAAoB,EAAE;AACzF,oCAAoC,+BAA+B,EAAE,cAAc,EAAE;AACrF,iCAAiC,4BAA4B,EAAE,kBAAkB,EAAE;AACnF,oCAAoC,+BAA+B,EAAE,qBAAqB,EAAE;AAC5F,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;;AAEzE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,4EAA4E;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,yBAAyB,+BAA+B,EAAE,cAAc,EAAE;AAC1E,yBAAyB,+BAA+B,EAAE,cAAc,EAAE;AAC1E,wBAAwB,8BAA8B,EAAE,cAAc,EAAE;AACxE,sBAAsB,4BAA4B,EAAE,cAAc,EAAE;AACpE,wBAAwB,+BAA+B,EAAE,qBAAqB,EAAE;AAChF,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uBAAuB,uBAAuB,EAAE;AAChD,0BAA0B,0BAA0B,EAAE;AACtD,0BAA0B,0BAA0B,EAAE;AACtD,yBAAyB,yBAAyB,EAAE;AACpD,yBAAyB,0BAA0B,EAAE;;AAErD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA,0BAA0B,8BAA8B,EAAE,oBAAoB,EAAE;AAChF,2BAA2B,+BAA+B,EAAE,cAAc,EAAE;AAC5E,wBAAwB,4BAA4B,EAAE,kBAAkB,EAAE;AAC1E,2BAA2B,+BAA+B,EAAE,qBAAqB,EAAE;;AAEnF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB,oBAAoB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACzF,uBAAuB,cAAc,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACpF,oBAAoB,kBAAkB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;AACrF,sBAAsB,WAAW,EAAE,gCAAgC,EAAE,0BAA0B,EAAE;;AAEjG;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;0DAC0D;AAC1D;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,uBAAuB;IACvB,4BAA4B;IAC5B,qDAAqD;IACrD,4BAA4B;IAC5B,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,WAAW;IACX,SAAS;IACT,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;;;EAGE,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Agency360 / ViiB portal design system */\n\nbody {\n  font-family: var(--font);\n  background: var(--bg);\n  color: var(--text);\n  -webkit-font-smoothing: antialiased;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  color: var(--text);\n  letter-spacing: -0.02em;\n}\n\na {\n  color: var(--primary);\n}\n\na:hover {\n  color: var(--primary-hover);\n  text-decoration: none;\n}\n\n.muted {\n  color: var(--text-muted);\n}\n\n.eyebrow {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 0.2rem;\n}\n\n.btn-primary,\n.btn-secondary,\n.btn-danger,\n.btn-link {\n  font-family: inherit;\n  font-weight: 600;\n  border-radius: 10px;\n  padding: 0.55rem 1.05rem;\n  font-size: 0.9rem;\n  line-height: 1.25;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: #fff;\n  border: 1px solid var(--primary);\n  box-shadow: 0 1px 2px rgb(79 70 229 / 25%);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n  color: #fff;\n}\n\n.btn-secondary {\n  background: #fff;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--primary-soft);\n  border-color: #c7d2fe;\n  color: var(--primary);\n}\n\n.btn-danger {\n  background: var(--danger);\n  color: #fff;\n  border: 1px solid var(--danger);\n}\n\n.btn-link {\n  background: #fff;\n  color: var(--primary);\n  border: 1px solid var(--border);\n}\n\n.btn-link:hover {\n  background: var(--primary-soft);\n  border-color: #c7d2fe;\n}\n\n.auth-shell {\n  background:\n    radial-gradient(circle at top left, rgb(79 70 229 / 10%), transparent 34%),\n    radial-gradient(circle at bottom right, rgb(59 130 246 / 10%), transparent 32%),\n    var(--bg);\n}\n\n.auth-card,\n.auth-card.flat,\n.card-panel,\n.table-wrap {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n}\n\n.auth-card {\n  padding: 2rem 1.75rem;\n}\n\n.auth-card.flat {\n  padding: 1.15rem 1.2rem;\n  box-shadow: var(--shadow);\n}\n\n.auth-card h1 {\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n.field span {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']),\n  .field > textarea,\n  .field > select,\n  .stack > input:not([type='checkbox']):not([type='radio']):not([type='file']):not([type='hidden']),\n  .stack > textarea,\n  .stack > select,\n  .inline-two input:not([type='checkbox']):not([type='radio']),\n  .inline-two select,\n  .row-actions > select,\n  .form-control,\n  .form-select,\n  .searchable-select-trigger\n) {\n  border-radius: 10px;\n  border-color: #dbe3ee;\n  box-shadow: none;\n}\n\n:is(\n  .field > input:not([type='checkbox']):not([type='radio']):focus,\n  .field > textarea:focus,\n  .field > select:focus,\n  .form-control:focus,\n  .form-select:focus,\n  .searchable-select-trigger:focus\n) {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgb(79 70 229 / 15%);\n  outline: none;\n}\n\n.dashboard {\n  background: var(--portal-content-bg, var(--bg));\n}\n\n.app-shell.dashboard {\n  display: grid;\n  grid-template-columns: 16.75rem minmax(0, 1fr);\n  min-height: 100vh;\n  transition: grid-template-columns 0.2s ease;\n}\n\n.app-shell.dashboard.is-sidebar-collapsed {\n  grid-template-columns: 0 minmax(0, 1fr);\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  min-width: 0;\n  padding: 1.15rem 0.9rem 0.9rem;\n  background: #f1f3f9;\n  border-right: 1px solid #e6eaf2;\n  overflow: hidden;\n}\n\n.app-shell.is-sidebar-collapsed .sidebar {\n  padding: 0;\n  border-right: 0;\n  visibility: hidden;\n}\n\n.sidebar .portal-brand-header {\n  padding: 0 0.45rem 1rem;\n}\n\n.sidebar .portal-brand-header h1 {\n  font-size: 1.02rem;\n  line-height: 1.2;\n  color: #3f51b5;\n}\n\n.portal-brand-header--wordmark {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.2rem;\n}\n\n.agency-wordmark {\n  display: block;\n  height: 1.35rem;\n  width: auto;\n  max-width: 11.5rem;\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 0.15rem;\n}\n\n.sidebar-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  flex-shrink: 0;\n}\n\n.sidebar-link,\n.sidebar-group-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  width: 100%;\n  padding: 0.58rem 0.7rem;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #475569;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.sidebar-link:hover,\n.sidebar-group-trigger:hover {\n  background: #e8eefc;\n  color: #3f51b5;\n  text-decoration: none;\n}\n\n.sidebar-link.is-active,\n.sidebar-group.is-active > .sidebar-group-trigger {\n  background: #e3eafc;\n  color: #3f51b5;\n  font-weight: 700;\n}\n\n.sidebar-group-label {\n  flex: 1;\n}\n\n.sidebar-group-chevron {\n  font-size: 0.65rem;\n  opacity: 0.7;\n  transition: transform 0.15s ease;\n}\n\n.sidebar-group.is-open .sidebar-group-chevron {\n  transform: rotate(180deg);\n}\n\n.sidebar-group-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding: 0.15rem 0 0.35rem 1.85rem;\n}\n\n.sidebar-group-panel[hidden] {\n  display: none;\n}\n\n.sidebar-more-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding: 0.1rem 0 0.15rem 0.45rem;\n}\n\n.sidebar-more-panel[hidden] {\n  display: none;\n}\n\n.sidebar-sublink {\n  padding: 0.42rem 0.65rem;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 0.84rem;\n  text-decoration: none;\n}\n\n.sidebar-sublink:hover {\n  background: #f8fafc;\n  color: var(--text);\n  text-decoration: none;\n}\n\n.sidebar-sublink.is-active {\n  background: var(--primary-soft);\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding-top: 0.75rem;\n}\n\n.sidebar-help {\n  padding: 0.9rem 0.85rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.sidebar-help strong {\n  display: block;\n  font-size: 0.88rem;\n}\n\n.sidebar-help p {\n  margin: 0.3rem 0 0.7rem;\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n.sidebar-help-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.4rem 0.7rem;\n  border-radius: 8px;\n  background: #eef2ff;\n  color: #3f51b5;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.sidebar-help-btn:hover {\n  background: #e0e7ff;\n  color: #3f51b5;\n  text-decoration: none;\n}\n\n.app-shell-body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-height: 4rem;\n  padding: 0.7rem 1.5rem;\n  background: var(--portal-header-bg, var(--surface));\n  border-bottom: 1px solid var(--border);\n}\n\n.topbar-spacer {\n  flex: 1;\n}\n\n.topbar-search {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex: 1;\n  max-width: 36rem;\n  min-width: 0;\n  margin: 0;\n  padding: 0.45rem 0.85rem;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.topbar-search input {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: var(--text);\n  font: inherit;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.topbar-utilities {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.icon-btn.topbar-menu-btn {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.sidebar-backdrop {\n  display: none;\n}\n\n.dashboard-header {\n  display: none;\n}\n\n.dashboard-header h1 {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.portal-brand-logo {\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 10px;\n}\n\n.brand-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 10px;\n  background: var(--primary);\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.header-nav {\n  flex: 1;\n  justify-content: flex-end;\n  gap: 0.15rem;\n}\n\n.header-nav-link,\n.nav-dropdown-trigger {\n  padding: 0.5rem 0.7rem;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  color: var(--text-muted);\n  font-weight: 500;\n  box-shadow: none;\n}\n\n.header-nav-link:hover,\n.nav-dropdown-trigger:hover,\n.nav-dropdown.is-open .nav-dropdown-trigger {\n  background: transparent;\n  color: var(--text);\n  border-color: transparent;\n}\n\n.header-nav-link.is-active,\n.nav-dropdown.is-active .nav-dropdown-trigger {\n  background: transparent;\n  border: none;\n  color: var(--primary);\n  font-weight: 600;\n  box-shadow: inset 0 -2px 0 var(--primary);\n}\n\n.nav-dropdown-panel {\n  border-radius: 12px;\n  border-color: var(--border);\n  box-shadow: var(--shadow-md);\n  padding: 0.4rem;\n}\n\n.nav-dropdown-item {\n  border-radius: 8px;\n}\n\n.nav-dropdown-item.is-active {\n  background: var(--primary-soft);\n  color: var(--primary);\n}\n\n.header-nav-utilities {\n  gap: 0.45rem;\n  padding-left: 0.9rem;\n  margin-left: 0.5rem;\n}\n\n.dashboard-main {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 1.5rem 1.5rem 3rem;\n}\n\n.icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.icon-btn:hover {\n  background: var(--primary-soft);\n  border-color: #c7d2fe;\n  color: var(--primary);\n}\n\n.icon-btn-badge {\n  position: absolute;\n  top: -0.2rem;\n  right: -0.2rem;\n  min-width: 1.05rem;\n  height: 1.05rem;\n  padding: 0 0.25rem;\n  border-radius: 999px;\n  background: var(--danger);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  line-height: 1.05rem;\n  text-align: center;\n}\n\n.priority-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  background: var(--primary-soft);\n  color: var(--primary);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.user-menu {\n  position: relative;\n}\n\n.user-menu-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.15rem 0.4rem 0.15rem 0.15rem;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: transparent;\n  cursor: pointer;\n  color: inherit;\n}\n\n.user-menu-trigger:hover,\n.user-menu.is-open .user-menu-trigger {\n  background: #f8fafc;\n  border-color: var(--border);\n}\n\n.user-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 999px;\n  background: var(--primary);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.user-menu-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n  text-align: left;\n}\n\n.user-menu-name {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.user-menu-role {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n}\n\n.user-menu-panel {\n  display: none;\n  position: absolute;\n  right: 0;\n  top: calc(100% + 0.4rem);\n  min-width: 12rem;\n  padding: 0.35rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n  z-index: 220;\n}\n\n.user-menu.is-open .user-menu-panel {\n  display: block;\n}\n\n.user-menu-item {\n  display: block;\n  width: 100%;\n  padding: 0.55rem 0.7rem;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text);\n  font-size: 0.9rem;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.user-menu-item:hover {\n  background: #f8fafc;\n  color: var(--text);\n}\n\n.notif-bell {\n  position: relative;\n}\n\n.notif-bell-panel {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 0.45rem);\n  z-index: 230;\n  width: min(22rem, 80vw);\n  padding: 0.9rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n}\n\n.notif-bell-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.65rem;\n}\n\n.page-welcome {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1.35rem;\n}\n\n.page-welcome-title {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n}\n\n.page-welcome-sub {\n  margin: 0.3rem 0 0;\n  color: var(--text-muted);\n}\n\n.page-welcome-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.stat-grid,\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.9rem;\n}\n\n.kpi-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 1rem 1.05rem 0.9rem;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  text-decoration: none;\n  color: inherit;\n}\n\n.kpi-card--link:hover {\n  border-color: #c7d2fe;\n  box-shadow: var(--shadow-md);\n  text-decoration: none;\n  color: inherit;\n}\n\n.kpi-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.kpi-card-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.15rem;\n  height: 2.15rem;\n  border-radius: 10px;\n}\n\n.kpi-card--purple .kpi-card-icon { background: var(--primary-soft); color: var(--primary); }\n.kpi-card--danger .kpi-card-icon { background: var(--danger-soft); color: var(--danger); }\n.kpi-card--warning .kpi-card-icon { background: var(--warning-soft); color: #d97706; }\n.kpi-card--info .kpi-card-icon { background: var(--info-soft); color: var(--info); }\n.kpi-card--success .kpi-card-icon { background: var(--success-soft); color: var(--success); }\n.kpi-card--default .kpi-card-icon { background: #f1f5f9; color: #475569; }\n\n.kpi-card-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.kpi-card-value {\n  font-size: 1.65rem;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1;\n}\n\n.kpi-card-hint,\n.kpi-card-link {\n  font-size: 0.8rem;\n  color: var(--primary);\n}\n\n.kpi-card-hint {\n  color: var(--text-muted);\n}\n\n.dash-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(18rem, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.dash-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 1.1rem 1.15rem;\n}\n\n.panel > * {\n  min-width: 0;\n}\n\n.panel h3,\n.panel-title {\n  margin: 0 0 0.85rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #334155;\n}\n\n.panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n  flex: none;\n}\n\n.panel-head h3,\n.panel-head .panel-title {\n  margin: 0;\n}\n\n.panel-link {\n  display: inline-flex;\n  align-items: center;\n  flex: none;\n  margin: 0;\n  padding: 0.28rem 0.7rem;\n  border: 1px solid #c7d2fe;\n  border-radius: 999px;\n  background: #fff;\n  color: var(--primary);\n  font-family: inherit;\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.panel-link:hover {\n  background: var(--primary-soft);\n  border-color: #a5b4fc;\n  color: var(--primary-hover);\n  text-decoration: none;\n}\n\n.panel-link:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgb(79 70 229 / 18%);\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.18rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.status-badge-dot {\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 999px;\n  background: currentColor;\n}\n\n.status-badge--success { background: var(--success-soft); color: #047857; }\n.status-badge--warning { background: var(--warning-soft); color: #b45309; }\n.status-badge--danger { background: var(--danger-soft); color: #b91c1c; }\n.status-badge--info { background: var(--info-soft); color: #1d4ed8; }\n.status-badge--purple { background: var(--primary-soft); color: var(--primary); }\n.status-badge--rose { background: #fdf4ff; color: #a21caf; }\n.status-badge--neutral { background: #f1f5f9; color: #475569; }\n\n.progress-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.progress-block-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.progress-track {\n  height: 8px;\n  border-radius: 999px;\n  background: #eef2f7;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  border-radius: 999px;\n}\n\n.progress-fill--info { background: var(--info); }\n.progress-fill--success { background: var(--success); }\n.progress-fill--warning { background: var(--warning); }\n.progress-fill--danger { background: var(--danger); }\n.progress-fill--purple { background: var(--primary); }\n\n.attention-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.attention-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fff;\n  text-decoration: none;\n  color: inherit;\n}\n\n.attention-item:hover {\n  border-color: #c7d2fe;\n  text-decoration: none;\n  color: inherit;\n}\n\n.attention-item--button {\n  width: 100%;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.attention-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n  flex: 1;\n}\n\n.attention-action {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--primary);\n  white-space: nowrap;\n}\n\n.attention-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.attention-icon--danger { background: var(--danger-soft); color: var(--danger); }\n.attention-icon--warning { background: var(--warning-soft); color: #d97706; }\n.attention-icon--info { background: var(--info-soft); color: var(--info); }\n.attention-icon--success { background: var(--success-soft); color: var(--success); }\n\n.action-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.4rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.action-cta--danger { color: var(--danger); border: 1px solid #fecaca; background: #fff; }\n.action-cta--warning { color: #b45309; border: 1px solid #fde68a; background: #fff; }\n.action-cta--info { color: var(--info); border: 1px solid #bfdbfe; background: #fff; }\n.action-cta--purple { color: #fff; border: 1px solid var(--primary); background: var(--primary); }\n\n.timeline-stages {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.timeline-stages li {\n  position: relative;\n  padding: 0 0 1rem 1.6rem;\n  border-bottom: none;\n}\n\n.timeline-stages li:last-child {\n  padding-bottom: 0;\n}\n\n.timeline-stages li::before {\n  content: '';\n  position: absolute;\n  left: 0.42rem;\n  top: 1.15rem;\n  bottom: 0;\n  width: 2px;\n  background: #e2e8f0;\n}\n\n.timeline-stages li:last-child::before {\n  display: none;\n}\n\n.timeline-dot {\n  position: absolute;\n  left: 0;\n  top: 0.15rem;\n  width: 0.95rem;\n  height: 0.95rem;\n  border-radius: 999px;\n  border: 2px solid #cbd5e1;\n  background: #fff;\n}\n\n.timeline-dot--done {\n  background: var(--success);\n  border-color: var(--success);\n}\n\n.timeline-dot--current {\n  background: var(--info);\n  border-color: var(--info);\n  box-shadow: 0 0 0 4px rgb(59 130 246 / 18%);\n}\n\n.help-card {\n  background: linear-gradient(180deg, #eef2ff 0%, #fff 48%);\n  border-color: #e0e7ff;\n}\n\n.help-card .help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 12px;\n  background: var(--primary);\n  color: #fff;\n  margin-bottom: 0.7rem;\n}\n\n.track-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding: 0.95rem 1.15rem;\n  border-radius: var(--radius);\n  background: #eff6ff;\n  border: 1px solid #dbeafe;\n  color: #1e40af;\n  font-weight: 600;\n}\n\n.project-hero {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 1.2rem 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.project-hero-crumb {\n  margin-bottom: 0.75rem;\n  font-size: 0.85rem;\n}\n\n.project-hero-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.project-hero-identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  min-width: 0;\n}\n\n.project-hero-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 14px;\n  background: var(--primary-soft);\n  color: var(--primary);\n  font-weight: 800;\n  font-size: 1.2rem;\n}\n\n.project-hero-title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n}\n\n.project-hero-title {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 800;\n}\n\n.project-hero-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.project-hero-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));\n  gap: 0.85rem;\n  margin-top: 1rem;\n}\n\n.workspace-tabs {\n  gap: 0.15rem;\n  border-bottom: 1px solid var(--border);\n  margin-top: 0.25rem;\n}\n\n.workspace-tab {\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  border-radius: 0;\n  padding: 0.7rem 0.85rem;\n  font-weight: 600;\n}\n\n.workspace-tab.active {\n  background: transparent;\n  color: var(--primary);\n  box-shadow: inset 0 -2px 0 var(--primary);\n}\n\n.data-table th {\n  background: #f8fafc;\n  font-size: 0.72rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.data-table td {\n  padding: 0.8rem 0.9rem;\n  vertical-align: middle;\n}\n\n/* Keep action cells in the table grid. display:flex on a td drops it out of\n   the row, so borders and buttons shift on taller rows. */\ntable :is(td, th).row-actions {\n  display: table-cell;\n  width: 1%;\n  white-space: nowrap;\n  text-align: right;\n  vertical-align: middle;\n}\n\ntable :is(td, th).row-actions > * {\n  vertical-align: middle;\n}\n\ntable :is(td, th).row-actions > * + * {\n  margin-left: 0.5rem;\n}\n\n.data-table tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.quick-nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.85rem;\n  margin-top: 1.25rem;\n  padding: 0.85rem 1rem;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n.quick-nav a {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.quick-nav a:hover {\n  color: var(--primary);\n}\n\n.empty-state {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.feed-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.feed-list li {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.7rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.feed-list li:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.dropzone {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 8.5rem;\n  padding: 1.25rem;\n  border: 1.5px dashed #c7d2fe;\n  border-radius: 14px;\n  background: #f8faff;\n  text-align: center;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n.dropzone:hover,\n.dropzone.is-active {\n  border-color: var(--primary);\n  background: #eef2ff;\n  text-decoration: none;\n  color: inherit;\n}\n\n.dropzone.is-busy {\n  cursor: progress;\n}\n\n.dropzone input[type='file'] {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.asset-drop-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgb(238 242 255 / 88%);\n  pointer-events: none;\n}\n\n.asset-drop-overlay-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: min(28rem, 100%);\n  padding: 2rem 1.5rem;\n  border: 2px dashed var(--primary);\n  border-radius: 16px;\n  background: #fff;\n  text-align: center;\n}\n\n.chat-widget-fab {\n  background: var(--primary);\n  box-shadow: 0 8px 24px rgb(79 70 229 / 28%);\n}\n\n.modal-panel {\n  border-radius: 16px;\n}\n\n.dashboard-main h2[data-tour=\"page-title\"] {\n  font-size: 1.55rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.dashboard-integrations-card h3 {\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.kpi-mini-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n}\n\n.kpi-mini {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.7rem 0.9rem;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.kpi-mini:hover {\n  border-color: #c7d2fe;\n  text-decoration: none;\n  color: inherit;\n}\n\n.kpi-mini strong {\n  font-size: 1.15rem;\n  letter-spacing: -0.03em;\n}\n\n.my-work {\n  margin-bottom: 1.35rem;\n}\n\n.my-work-counts {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(7.5rem, 1fr));\n  gap: 0.65rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.my-work-count {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.my-work-count strong {\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1;\n}\n\n.my-work-count span {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.my-work-count.is-zero strong {\n  color: #94a3b8;\n}\n\n.my-work-count--danger:not(.is-zero) {\n  background: var(--danger-soft);\n  border-color: transparent;\n}\n\n.my-work-count--danger:not(.is-zero) strong {\n  color: #b91c1c;\n}\n\n.my-work-count--warning:not(.is-zero) {\n  background: var(--warning-soft);\n  border-color: transparent;\n}\n\n.my-work-count--warning:not(.is-zero) strong {\n  color: #b45309;\n}\n\n.my-work-count--info:not(.is-zero) {\n  background: var(--info-soft);\n  border-color: transparent;\n}\n\n.my-work-count--info:not(.is-zero) strong {\n  color: #1d4ed8;\n}\n\n.my-work-count--neutral:not(.is-zero) {\n  background: #f1f5f9;\n  border-color: transparent;\n}\n\n.my-work-empty {\n  margin: 0.85rem 0 0;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.my-work-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin: 0.9rem 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.my-work .my-work-task {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fff;\n  color: var(--text);\n  text-decoration: none;\n}\n\n.my-work .my-work-task:hover {\n  border-color: #c7d2fe;\n  color: var(--text);\n  text-decoration: none;\n}\n\n.my-work .my-work-task .muted {\n  color: var(--text-muted);\n}\n\n.my-work-list,\n.my-work-list > li {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.my-work-task-copy {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.12rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.my-work-task-copy strong {\n  display: block;\n  overflow: hidden;\n  font-size: 0.92rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chip-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.85rem;\n}\n\n.chip-tab {\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text-muted);\n  border-radius: 999px;\n  padding: 0.35rem 0.8rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.chip-tab.is-active {\n  background: var(--primary-soft);\n  border-color: #c7d2fe;\n  color: var(--primary);\n}\n\n.scope-toggle {\n  display: inline-flex;\n  padding: 0.2rem;\n  border-radius: 999px;\n  background: #eef2ff;\n  border: 1px solid #e0e7ff;\n}\n\n.scope-toggle button {\n  border: 0;\n  background: transparent;\n  color: var(--text-muted);\n  border-radius: 999px;\n  padding: 0.4rem 0.85rem;\n  font-weight: 700;\n  font-size: 0.8rem;\n  cursor: pointer;\n}\n\n.scope-toggle button.is-active {\n  background: var(--primary);\n  color: #fff;\n}\n\n.lead-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.lead-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.55rem;\n  height: 1.55rem;\n  border-radius: 999px;\n  background: var(--primary-soft);\n  color: var(--primary);\n  font-size: 0.65rem;\n  font-weight: 800;\n}\n\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.55rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.file-row:last-child {\n  border-bottom: 0;\n}\n\n.file-glyph {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 8px;\n  background: var(--success-soft);\n  color: var(--success);\n  font-size: 0.65rem;\n  font-weight: 800;\n}\n\n.connected-apps {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.connected-app {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.55rem 0.7rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n}\n\n.donut-wrap {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.donut {\n  width: 7.5rem;\n  height: 7.5rem;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.workspace-tabs-more {\n  position: relative;\n}\n\n.workspace-more-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 0.35rem);\n  z-index: 8;\n  min-width: 12rem;\n  padding: 0.35rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n}\n\n.workspace-more-menu button {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 0.5rem 0.7rem;\n  border-radius: 8px;\n  font: inherit;\n  font-weight: 600;\n  color: var(--text);\n  cursor: pointer;\n}\n\n.workspace-more-menu button:hover,\n.workspace-more-menu button.is-active {\n  background: var(--primary-soft);\n  color: var(--primary);\n}\n\n.hero-more {\n  position: relative;\n}\n\n.hero-more-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 0.35rem);\n  z-index: 8;\n  min-width: 13rem;\n  padding: 0.35rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n}\n\n.hero-more-menu button,\n.hero-more-menu a {\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 0.5rem 0.7rem;\n  border-radius: 8px;\n  font: inherit;\n  font-weight: 600;\n  color: var(--text);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.hero-more-menu button:hover,\n.hero-more-menu a:hover {\n  background: #f8fafc;\n  text-decoration: none;\n}\n\n.hero-more-menu .is-danger {\n  color: var(--danger);\n}\n\n.usage-stat {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.55rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.usage-stat:last-child {\n  border-bottom: 0;\n}\n\n.panel-search {\n  min-width: 12rem;\n  flex: 1;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 1024px) {\n  .dash-grid,\n  .dash-grid-3,\n  .kpi-mini-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .my-work-counts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .my-work .my-work-task {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .my-work-task-copy {\n    flex: none;\n    width: 100%;\n  }\n\n  .my-work .my-work-task .status-badge {\n    align-self: flex-start;\n  }\n}\n\n@media (max-width: 960px) {\n  .app-shell,\n  .app-shell.dashboard,\n  .app-shell.dashboard.is-sidebar-collapsed {\n    grid-template-columns: 1fr;\n  }\n\n  .icon-btn.topbar-menu-btn {\n    display: inline-flex;\n  }\n\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: min(18rem, 86vw);\n    transform: translateX(-110%);\n    transition: transform 0.2s ease, visibility 0.2s ease;\n    box-shadow: var(--shadow-md);\n    visibility: hidden;\n    padding: 1.15rem 0.9rem 0.9rem;\n    border-right: 1px solid #e6eaf2;\n  }\n\n  .app-shell.is-sidebar-open .sidebar {\n    transform: none;\n    visibility: visible;\n  }\n\n  .sidebar-backdrop {\n    display: none;\n    position: fixed;\n    inset: 0;\n    z-index: 25;\n    border: 0;\n    background: rgb(15 23 42 / 45%);\n  }\n\n  .app-shell.is-sidebar-open .sidebar-backdrop {\n    display: block;\n  }\n}\n\n@media (max-width: 900px) {\n  .topbar .user-menu-meta {\n    display: none;\n  }\n\n  .page-welcome-title {\n    font-size: 1.4rem;\n  }\n\n  .action-cta {\n    width: 100%;\n  }\n}\n\n.form-choice-list {\n  display: grid;\n  gap: 0.35rem;\n}\n\n.form-choice {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-weight: 600;\n}\n\n.form-rating {\n  display: flex;\n  gap: 0.35rem;\n}\n\n.form-rating-btn {\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  font-weight: 700;\n}\n\n.form-rating-btn.is-on {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #fff;\n}\n\n.media-library-page,\n.media-library {\n  width: 100%;\n}\n\n.media-library-page > .auth-card:first-child {\n  position: relative;\n  z-index: 2;\n}\n\n.media-library-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-bottom: 0.75rem;\n}\n\n.media-library-head .panel-title {\n  margin-bottom: 0.2rem;\n}\n\n.media-upload-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 0.5rem;\n}\n\n.dropzone--compact {\n  min-height: 4.25rem;\n  padding: 0.75rem 1rem;\n}\n\n.media-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  align-items: center;\n  margin: 0.25rem 0 0.9rem;\n}\n\n.media-toolbar input[type='search'] {\n  flex: 1 1 12rem;\n  min-width: 10rem;\n}\n\n.media-filters,\n.media-view-toggle {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n.media-filters button,\n.media-view-toggle button,\n.media-menu-panel button {\n  border: 1px solid var(--border);\n  background: #fff;\n  border-radius: 999px;\n  padding: 0.28rem 0.7rem;\n  font-size: 0.8rem;\n  cursor: pointer;\n}\n\n.media-filters button.is-active,\n.media-view-toggle button.is-active {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: #fff;\n}\n\n.media-sort {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.media-sort select {\n  min-width: 8rem;\n}\n\n.media-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.85rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.media-card {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: #fff;\n  min-width: 0;\n}\n\n.media-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  padding: 0;\n  border: 0;\n  border-bottom: 1px solid var(--border);\n  border-radius: 11px 11px 0 0;\n  background: #f1f5f9;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.media-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.media-preview--missing {\n  color: #b91c1c;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.media-type-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 3.4rem;\n  height: 2.2rem;\n  padding: 0 0.45rem;\n  border-radius: 8px;\n  background: #e2e8f0;\n  color: #1e293b;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.media-type-icon--document {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.media-type-icon--video {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.media-type-icon--image {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.media-card-body {\n  padding: 0.65rem 0.7rem 0.75rem;\n}\n\n.media-card-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.35rem;\n}\n\n.media-card-title strong {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.9rem;\n}\n\n.media-card-meta {\n  margin-top: 0.2rem;\n}\n\n.media-menu {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.media-menu-button {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  line-height: 1;\n  padding: 0.15rem 0.25rem;\n}\n\n.media-menu-panel {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: 30;\n  display: grid;\n  min-width: 11rem;\n  padding: 0.35rem;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  box-shadow: var(--shadow);\n}\n\n.media-menu-panel button {\n  border-radius: 8px;\n  text-align: left;\n  background: transparent;\n}\n\n.media-menu-panel button.is-danger {\n  color: #b91c1c;\n}\n\n.media-table button.linkish {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  color: var(--primary);\n  cursor: pointer;\n  font-weight: 600;\n  text-align: left;\n}\n\n.media-pending {\n  margin-bottom: 0.9rem;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid #fde68a;\n  border-radius: 10px;\n  background: #fffbeb;\n}\n\n.media-pending h4 {\n  margin: 0 0 0.4rem;\n  font-size: 0.9rem;\n}\n\n.media-pending ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.media-pending li {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.25rem 0;\n}\n\n.media-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  background: rgb(15 23 42 / 88%);\n  color: #fff;\n}\n\n.media-lightbox-bar {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: center;\n  padding: 0.85rem 1rem;\n}\n\n.media-lightbox-bar strong {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.media-lightbox-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.media-lightbox-stage {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1.5rem 1.5rem;\n}\n\n.media-lightbox-stage img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.media-lightbox-note,\n.media-lightbox-file {\n  max-width: 28rem;\n  text-align: center;\n  color: #e2e8f0;\n}\n\n.media-lightbox-file {\n  display: grid;\n  justify-items: center;\n  gap: 0.45rem;\n}\n\n@media (max-width: 720px) {\n  .media-grid {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  }\n\n  .media-lightbox-bar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.access-layout {\n  display: grid;\n  grid-template-columns: minmax(14rem, 18rem) minmax(0, 1fr);\n  gap: 1.25rem;\n  align-items: start;\n}\n\n.access-roles,\n.access-editor,\n.access-member,\n.access-group {\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  background: #fff;\n  padding: 1rem;\n}\n\n.access-role-list {\n  list-style: none;\n  margin: 0 0 1rem;\n  padding: 0;\n  display: grid;\n  gap: 0.4rem;\n}\n\n.access-role {\n  width: 100%;\n  text-align: left;\n  border: 1px solid transparent;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 0.55rem 0.7rem;\n  display: grid;\n  gap: 0.15rem;\n}\n\n.access-role.active {\n  border-color: var(--primary, #2563eb);\n  background: #eff6ff;\n}\n\n.access-group-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: flex-start;\n}\n\n.access-group h4,\n.access-roles h3,\n.access-editor h3,\n.access-member h3 {\n  margin: 0 0 0.35rem;\n}\n\n.access-permissions,\n.access-overrides {\n  list-style: none;\n  margin: 0.75rem 0 0;\n  padding: 0;\n  display: grid;\n  gap: 0.55rem;\n}\n\n.access-permissions label {\n  display: flex;\n  gap: 0.65rem;\n  align-items: flex-start;\n}\n\n.access-permissions label span {\n  display: grid;\n  gap: 0.1rem;\n}\n\n.access-overrides li {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 12rem;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.access-editor,\n.access-member {\n  display: grid;\n  gap: 0.85rem;\n}\n\n@media (max-width: 900px) {\n  .access-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .access-overrides li {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
